export default "https://cdn-static.gokick.com/assets/a067049b7600101c8dd9c58c97ab0ac81c37d227/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";